import { Box } from '@mui/material';
import React from 'react';

import { VoiceCallAgentIntegrationProvider } from '../context/VoiceCallAgentIntegration';
import styles from './VoiceCallAgentIntegrations.module.scss';
import VyseIntegration from './VyseIntegration/VyseIntegration';

const VoiceCallAgentIntegrations = () => {
  return (
    <VoiceCallAgentIntegrationProvider>
      <Box id={styles.VoiceCallAgentIntegrations}>
        <VyseIntegration />
      </Box>
    </VoiceCallAgentIntegrationProvider>
  );
};

export default VoiceCallAgentIntegrations;
